import {
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  VStack,
} from '@chakra-ui/react';
import {
  useCheckInOrderedProject,
  useFinishOrderedProject,
} from '~/common/api/orderingServiceApi/OrderingApi';
import { LabeledText } from '~/common/components/defaultUIComponents/LabeledText';
import { Button } from '~/common/components/defaultUIComponents/Button';
import { useUsers } from '~/common/api/zeiterfassungServerApi/UsersApi';
import { OrderedProjectHistory, HistoryType } from '@its4plan/ordering';
import { formatUsername } from '~/common/utils/employeeUtils';
import useTranslate from '~/common/utils/translate';
import { format } from 'date-fns';
import _ from 'lodash';

export function OrderProjectHistoryModal(props: {
  checkedIn: boolean;
  history: OrderedProjectHistory[];
  orderedProjectId: number;
  isOpen: boolean;
  onToggle: () => void;
  finish: boolean;
}) {
  const t = useTranslate();
  const { data: users = {} } = useUsers();

  const { mutate: checkInOrderedProject, isLoading: checkInLoading } =
    useCheckInOrderedProject({
      onSuccess: () => {
        props.onToggle();
      },
    });

  const { mutate: finishOrderedProject, isLoading: finishLoading } =
    useFinishOrderedProject({
      onSuccess: () => {
        props.onToggle();
      },
    });

  return (
    <Modal isOpen={props.isOpen} onClose={props.onToggle}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {props.finish
            ? t('ordertile.modal.finishOrder.dialogHeaderText')
            : t('ordertile.history.dialogHeaderText')}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {props.finish ? (
            <Button
              isDisabled={finishLoading}
              onClick={() =>
                finishOrderedProject({ id: props.orderedProjectId })
              }
            >
              {t('ordertile.modal.button2')}
            </Button>
          ) : (
            <Button
              isDisabled={props.checkedIn || checkInLoading}
              onClick={() =>
                checkInOrderedProject({ id: props.orderedProjectId })
              }
            >
              {t('ordertile.modal.button1')}
            </Button>
          )}
          {_.orderBy(props.history, (history) => history.doneAt, 'desc').map(
            (history) => (
              <VStack
                key={history.id}
                spacing={0}
                alignItems="start"
                borderColor="gray.300"
                borderBottomWidth={1}
                py={2}
              >
                {history.type === HistoryType.DONE && (
                  <HStack>
                    <LabeledText label="ordertile.history.doneAmount">
                      {history.doneAmount}
                    </LabeledText>
                  </HStack>
                )}
                {history.type === HistoryType.CHECKED_IN && (
                  <HStack>
                    <LabeledText label="ordertile.history.checkedIn" />
                  </HStack>
                )}
                <HStack justifyContent="space-between" width="100%">
                  <LabeledText label="ordertile.history.changersName">
                    {formatUsername(users[history.changedBy])}
                  </LabeledText>
                  {history.doneAt && (
                    <LabeledText label="ordertile.history.doneAt">
                      {format(new Date(history.doneAt), 'dd.MM.yyyy HH:mm')}
                    </LabeledText>
                  )}
                </HStack>
                {history.comment && (
                  <HStack>
                    <LabeledText label="ordertile.history.comment">
                      {history.comment}
                    </LabeledText>
                  </HStack>
                )}
              </VStack>
            ),
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
